import {observable, action, runInAction, computed} from 'mobx'
import {json} from '../../../../utils/ajax'
import {message} from 'antd'

class UserStore {
    @observable loading
    @observable modal

    @observable search
    @observable pagination
    @observable list
    @observable roleList

    @observable forms
    @observable flag  //true修改 false 新增
    @observable alertVisible

    constructor() {
        this.loading = false
        this.modal = 'hide'

        this.search = {}
        this.pagination = {}
        this.list = []
        this.resources = []

        this.roleList = [];
        this.forms = {
            roles: []
        }
        this.flag = false
        this.alertVisible = false
    }

    @computed get fields() {
        let fields = {
            id: {value: this.forms.id},
            loginName: {value: this.forms.loginName},
            name: {value: this.forms.name},
            phone: {value: this.forms.phone},
            email: {value: this.forms.email},
            password: {value: this.forms.password},
            userId: {value: this.forms.userId},
            roles: {value: this.forms.roles.map(item => `${item.id}`)}
        }
        return fields;
    }

    /**
     * 查询
     * @param page 页码
     */
    @action searchRoleList = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        // 服务器page参数下标从0开始
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search = {}
        search.search = this.search.search;
        search.page = page;
        const res = await json.get(`${process.env.REACT_APP_API_URL}/users:search`, search)
        if (json.isError(res)) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content
            this.pagination = {
                total: res.totalElements,
                results: res.size,
                page: res.number + 1,
            }
            this.loading = false
        })
    }


    @action getRole = async (page) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/role:lists`)
        if (!json.isError(res)) {
            runInAction(() => {
                this.roleList = res.data;
            })
        }
    }
    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        if (!id) {
            runInAction(() => {
                this.forms = {
                    roles: []
                }
                this.loading = false
                this.modal = 'show'
                this.flag = false
            })
        } else {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/user/${id}`);
            runInAction(() => {
                this.forms = res.data
                this.loading = false
                this.modal = 'show'
                this.flag = true
            })
        }
    }

    /**
     * 保存
     */
    @action save = async () => {
        if (this.forms.id) {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/user/${this.forms.id}`, this.forms);
            // await json.put(`${process.env.REACT_APP_API_URL}/account:password/${this.forms.id}`, this.forms);
            if (res.status) {
                runInAction(() => {
                    message.success('修改成功!');
                })
            } else {
                runInAction(() => {
                    message.error('修改失败!');
                })
            }
        } else {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/user`, this.forms)
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/userOperationRecord/addUserOperationRecord/${this.forms.loginName}`)
            if (res.status) {
                runInAction(() => {
                    message.success('添加成功!');
                })
            } else {
                runInAction(() => {
                    message.error('添加失败!');
                })
            }
        }
        await this.searchRoleList(this.pagination.page)
        runInAction(() => {
            this.modal = 'hide'
        })
    }

    /**
     * 删除
     * @param id role id
     */
    @action del = async (id) => {
        await json.delete(`${process.env.REACT_APP_API_URL}/user:delete/${id}`);
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/userOperationRecord/delById/id/${id}`)
        await this.searchRoleList(this.pagination.page)
    }

    @action.bound
    cancelEdit() {
        this.loading = false
        this.modal = 'hide'
    }

    /**
     * 每次更新search框时，回写数据
     * @param values search数据
     */
    @action.bound
    onSearchFieldChange(values) {
        this.search = values
    }

    @action.bound
    onEditFieldChange(changedFields) {
        const fields = {...this.fields, ...changedFields}
        this.forms = {
            id: fields.id.value,
            userId: fields.userId.value,
            loginName: fields.loginName.value,
            name: fields.name.value,
            phone: fields.phone.value,
            email: fields.email.value,
            password: fields.password.value,
            roles: fields.roles.value.map(item => {
                return {
                    id: item
                }
            })
        }
    }

    @action
    resetPassword = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/users:resetPassword/${id}`)
        if (res.status) {
            runInAction(() => {
                // message.info("密码重置成功")
                this.alertVisible=true
            })
        } else {
            runInAction(() => {
                message.error("密码重置失败")
            })
        }

    }

    @action
    setAlertVisible=(alertVisible)=>{
        this.alertVisible=alertVisible
    }


}

export default new UserStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/system/User/store.js